import { handlePromiseActions } from 'redux-app/utils/reducer'
import { onShowError } from 'redux-app/modules/alerts'
import { getContacts } from 'api/client/actions/contacts'
import { loadingWrapper } from 'redux-app/utils/loadingWrapper'

export const onGetContacts = () => dispatch => {
  return dispatch(getContacts())
    .catch(error => {
      dispatch(onShowError(error))
      throw error
    })
}

const ACTION_HANDLERS = {
  [getContacts.toString()]: loadingWrapper('contacts', [
    null,
    (state, { payload: { result } }) => result,
    null,
  ]),
}

const initialState = {
  contacts: [],
}

export default handlePromiseActions(ACTION_HANDLERS, initialState)
